<template>
  <div>
    <b-container>
      <div class="mt-4 mb-2 row d-flex justify-content-between justify-content-between">
        <div class="col-8">
          <back-arrow :bilan-type="bilanType"
                      :params="{operationId: this.operationId}"
                      :sub-title-ope="this.operationName"
                      :title="$t('ScheduleSee')"
                      route-back="OperationShow"/>
        </div>
        <div class="col-4 justify-content-end d-flex">
          <div class="mr-4">
            <b-button class="mr-2" variant="outline-primary" @click="clickOnGlobalEdit">
              {{ $t('Modify.Globally') }}
            </b-button>
            <b-button variant="primary" @click="clickOnEdit">
              {{ $t('Modify') }}
            </b-button>
          </div>
        </div>

      </div>

      <b-card>
        <div class="col">
          <b-nav class="multi-tabs-field-navbar">
            <b-nav-item v-for="(lot, index) in operationLotsFiltered" :key="index + '-nav-key'"
                        :class="{ 'link-active': currentSection === index }"
                        class="multi-tabs-field-navbar-item"
                        @click.prevent="currentSection = index">
              {{ $t('OperationLot') + ' ' }}
              <span v-if="lot.lotCoPro">{{ lot.lotCoPro }} - </span>
              <span v-else>{{ (index + 1) }} - </span>
              <span v-if="lot.name">{{ lot.name }}</span>
            </b-nav-item>
          </b-nav>
        </div>
        <div class="mt-4">
          <div class="col-md-12 d-flex justify-content-between">
            <div class="medium-text mb-1 font-weight-bolder">
              {{ $t('SchedulePayment') }}
            </div>
            <div class="ml-auto medium-text mb-1 font-weight-bolder">
              {{ $t('ScheduleDocument') }}
            </div>
          </div>
          <div class="col-md-12 d-flex justify-content-between mt-2">
            <div
              v-if="operationLotsFiltered[currentSection] && operationLotsFiltered[currentSection].hasOwnProperty('schedule') && operationLotsFiltered[currentSection].schedule && operationLotsFiltered[currentSection].schedule.hasOwnProperty('paiements') && operationLotsFiltered[currentSection].schedule.paiements && operationLotsFiltered[currentSection].schedule.paiements.length > 0"
              class="row mb-1">
              <div v-for="paiement in operationLotsFiltered[currentSection].schedule.paiements"
                   class="w-100 d-flex align-items-center mb-3">
                <div class="col-8 d-flex align-items-center justify-content-start">
                  <div>
                    <div
                      v-html="$t('Schedule.template.show',{percent : paiement.percentage, name:paiement.name, date: formatDateFR(paiement.date), amount: formatMoneyEUR(paiement.amount)})"></div>
                    <div v-if="paiement.description" class="paiement-description mt-2 w-50">{{ paiement.description }}
                    </div>
                  </div>
                </div>
                <div class="col-4 d-flex align-items-center justify-content-end h-100">
                  <b-button class="ml-auto d-flex align-items-center justify-content-center button-height"
                            variant="outline-primary"
                            @click="openDocumentModal(paiement)">
                    <svg class="mr-2" fill="none" height="24" stroke="currentColor" stroke-linecap="round"
                         stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 0h24v24H0z" fill="none" stroke="none"/>
                      <path d="M14 3v4a1 1 0 0 0 1 1h4"/>
                      <path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"/>
                      <path d="M2 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"/>
                      <path d="M17 16.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0"/>
                      <path d="M9.5 15a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1 -3 0v-3a1.5 1.5 0 0 1 1.5 -1.5z"/>
                      <path d="M19.5 15l3 6"/>
                      <path d="M19.5 21l3 -6"/>
                    </svg>
                    {{ $t('ScheduleDocumentButton') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>

      <schedule-document-modal
        v-if="paiement"
        id="schedule-override-modal"
        :key="'scheduleModal-' + scheduleModalKey"
        :paiement="paiement"/>

    </b-container>

  </div>
</template>

<script>

import api from "../../../services/api"
import backArrow from "../../../components/b122/BackArrow";
import ScheduleDocumentModal from "./ScheduleDocumentModal.vue";

export default {
  name: "ScheduleShow",

  components: {
    ScheduleDocumentModal,
    backArrow,
  },

  props: {
    operationId: {
      type: String,
      required: true
    },
    operationType: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      operationLots: [],
      bilanType: null,
      operationName: null,
      currentSection: 0,
      fetchedOperationType: null,
      paiement: null,
      scheduleModalKey: 0,
    }
  },

  async mounted() {
    await this.fetchData()
  },

  computed: {
    effectiveOperationType() {
      return this.fetchedOperationType || this.operationType
    },
    operationLotsFiltered() {
      if (this.effectiveOperationType === 'DEFAULT') return []
      else if (this.effectiveOperationType === 'VIR') return this.operationLots.filter(lot => lot.isLotVir)
      return this.operationLots
    },
  },

  methods: {
    async fetchData() {
      if (this.operationId) {
        await this.getOperation()
      }
      await this.getOperationLots()
    },

    clickOnEdit() {
      this.$router.push({
        name: 'ScheduleEdit',
        params: {operationId: this.operationId, operationType: this.effectiveOperationType}
      });
    },

    clickOnGlobalEdit() {
      this.$router.push({
        name: 'ScheduleGlobalEdit',
        params: {operationId: this.operationId, operationType: this.effectiveOperationType}
      });
    },

    async getOperation() {
      if (this.operationId != null) {
        await api
          .get(`/operation/${this.operationId}`)
          .then(response => {
            this.bilanType = response.data.bilanType
            this.operationName = response.data.name
            this.fetchedOperationType = response.data.operationType
          })
      }
    },

    formatDateFR(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return "";
      const jour = String(date.getDate()).padStart(2, '0');
      const mois = String(date.getMonth() + 1).padStart(2, '0');
      const annee = date.getFullYear();
      return `${jour}/${mois}/${annee}`;
    },

    formatMoneyEUR(amount) {
      if (amount == null) return "";
      return new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'}).format(amount / 100);
    },

    async getOperationLots() {
      if (this.operationId) {
        await this.getInitialDateOperation()
        await this.getOperationLotsFromOperation()
      }
    },

    async getOperationLotsFromOperation() {
      await api
        .get(`/operationLot/getAllForOperation/${this.operationId}`)
        .then(response => {
          this.operationLots = response.data
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async getInitialDateOperation() {
      await api
        .get(`/operation/getInitialDateOperation/${this.operationId}`)
        .then(response => {
          this.operationInitialStartDate = response.data.estimatedStartDate
          this.operationInitialEndDate = response.data.estimatedEndDate
        })
        .catch((error) => {

        })
    },

    openDocumentModal(paiement) {
      this.paiement = paiement
      this.scheduleModalKey++
      setTimeout(() => {
        this.$bvModal.show('schedule-document-modal')
      }, 100);
    }
  }
}
</script>

<style scoped>
.paiement-description {
  color: #AAAAAA;
  font-weight: 400;
  vertical-align: bottom;
}

.button-height {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/operation/OperationSchedule/ScheduleShow.vue